module.exports = __webpack_public_path__ + "/images/cover-recibiendo-dinero.917dc27.png";